import BigNumber from "bignumber.js";
import { BlackScholes } from "./black-scholes";

export class BlackScholesLookup extends BlackScholes {
  sqrtTs: {[key: number]: BigNumber} = {};
  pvs: {[key: number]: BigNumber} = {};

  getSqrtTsAndPvs(timestamp: number, expiry: number, rate: BigNumber) {
    return [this.sqrtTs[expiry], this.pvs[expiry]];
  }
}
